import { memo } from 'react';
import { Layer, Source, SourceProps } from 'react-map-gl';

import { MAP_ZINDEX } from '../pf-map/pf-map';

/* eslint-disable-next-line */
export interface WmsLayerProps {
  url: string;
  maxbounds?: number[];
  id?: string;
  beforeId?: string;
  opacity?: number;
}

export const WmsLayer = memo(function WmsLayer(props: WmsLayerProps) {
  const sourceId = props.id ? `wms-source-${props.id}` : `wms-source`;

  const sourceProps: SourceProps = {};

  if (props.maxbounds) {
    sourceProps.bounds = props.maxbounds;
  }
  const formatUrl = (url: string) => {
    // replace the BBOX search parameter with {bbox-epsg-3857}
    const bbox = 'bbox-value';
    const urlObject = new URL(url);
    urlObject.searchParams.set('BBOX', bbox);
    urlObject.searchParams.set('CRS', 'EPSG:3857');

    urlObject.searchParams.delete('Geometry');
    return urlObject.href.replace(bbox, '{bbox-epsg-3857}');
  };

  return (
    <Source
      {...sourceProps}
      id={sourceId}
      minZoom={14}
      tileSize={256}
      tiles={[formatUrl(props.url)]}
      type="raster"
    >
      <Layer
        beforeId={props.beforeId ?? MAP_ZINDEX.Z_INDEX_1}
        id="wms-layer"
        minzoom={12}
        paint={{
          'raster-opacity': props.opacity ?? 1,
          'raster-opacity-transition': { duration: 0 },
        }}
        source="wms-sources"
        type="raster"
      />
    </Source>
  );
});

export default WmsLayer;
